import { faPlus, faRoute, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../app/store";
import { addListaUFPercurso, removeListaUFPercurso, removeListaUFPercursoTodos } from "../../../features/manifestoSlice";
import { useEffect, useState } from "react";
import { ButtonRemover, ButtonTrash, JTable, JTBody, JTHead, JvCaption } from "../../../components/Components";
import { infPercurso, SelectObjectRemoveInterface } from "../../../interfaces";
import { getUuidV4 } from "../../../utils/utils";
import RotaModal from "../rotas/RotaModal";
import { useQuestion } from "../../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../../components/ModalMessage/useModalMessage";

const initialEstadoPercurso: infPercurso = {
    id: 0,
    estado_id: 0,
    uf: ''
}

const limite: number = 25;

export default function UfPercurso() {
    const dispatch = useDispatch();
    const listaPercurso = useSelector((state: RootState) => state.manifesto.manifesto.infPercurso);
    const selectUfPercurso = useSelector((state: RootState) => state.manifesto.selectEstados);
    const form = useSelector((state: RootState) => state.manifesto.manifesto);
    const [formEstado, setFormEstado] = useState<infPercurso>(initialEstadoPercurso);
    const [showRota, setShowRota] = useState<boolean>(false);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();
    const [saldo, setSaldo] = useState<number>(0);
    const [selecionado, setSelecionado] = useState<number | string>('');

    const handleRemover = async (value: SelectObjectRemoveInterface) => {
        setSelecionado(value.id);
        const confirmed = await confirm({
            title: "Confirmação",
            message: <>Deseja realmente remover <strong>{value.title}</strong> ?</>
        })
        if (confirmed) {
            dispatch(removeListaUFPercurso(value.id.toString()));
        }
        setSelecionado('');
    }

    const removerTudo = async () => {
        if (listaPercurso.length > 0) {
            const confirmed = await confirm({
                title: "Confirmação",
                message: <>Remover todos ?</>
            })
            if (confirmed) {
                dispatch(removeListaUFPercursoTodos());
            }
        }
    }

    const handleCloseModalRota = () => {
        setShowRota(false);
    }

    const validarPreenchimentoMunCarregaAndUFiniUfFim = () => {
        if (form.infMunCarrega.length === 0) {
            alertModal('Informe primeiramente o município de carregamento.');
            return false;
        }

        if (form.ufini === form.uffim) {
            alertModal('Se UF Inicial e UF Fim forem iguais, não pode adicionar percurso.');
            return false;
        }
        return true;
    }
    const validarPreenchimento = () => {
        if (formEstado.estado_id.toString() === '0') {
            alertModal('Nenhum estado selecionado.');
            return false;
        }

        if (formEstado.uf.trim() === form.ufini || formEstado.uf.trim() === form.uffim) {
            alertModal('UF de percurso não pode ser igual a UF Inicial ou UF Final.');
            return false;
        }

        if (form.infPercurso.find((item) => item.uf === formEstado.uf.trim())) {
            alertModal('UF já adicionada');
            return false;
        }

        if (form.infPercurso.length === 25) {
            alertModal('Limite máximo de 25 UFs de percurso atingido.');
            return false;
        }

        if (!validarPreenchimentoMunCarregaAndUFiniUfFim()) return false;

        return true;
    }

    const handleRotas = () => {
        if (validarPreenchimentoMunCarregaAndUFiniUfFim()) {
            setShowRota(true);
        }
    }

    const handleAdd = () => {
        if (validarPreenchimento()) {
            dispatch(addListaUFPercurso({
                ...formEstado,
                id: getUuidV4()
            }));
        }
    }

    useEffect(() => {
        setSaldo(listaPercurso.length);
    }, [listaPercurso])


    return (<>
        <Card className="card-primary card-outline">
            <Card.Header className="fw-bold">
                <Card.Text>UFs de percurso</Card.Text>
            </Card.Header>
            <Card.Body className="p-3 " >
                <Row className="g-2">
                    <Col md={5}>
                        <Form.Group className="mb-2" controlId="uf_percurso">
                            <InputGroup>
                                <Form.Select name="uf_percurso"
                                    onChange={(e: any) => {
                                        setFormEstado({
                                            ...formEstado,
                                            estado_id: parseInt(e.target.value),
                                            uf: e.target.options[e.target.selectedIndex].text
                                        })
                                    }}
                                >
                                    {selectUfPercurso.map((estado) => (
                                        <option key={estado.id} value={estado.id}>
                                            {estado.uf === "" ? estado.name : estado.uf}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Button variant="primary" onClick={handleAdd}>
                                    <FontAwesomeIcon icon={faPlus} />
                                </Button>
                            </InputGroup>

                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mb-3">
                            <Button variant="success" onClick={() => handleRotas()}>
                                <FontAwesomeIcon icon={faRoute} className="me-1" />Rotas
                            </Button>
                        </Form.Group>

                    </Col>
                </Row>

                <Row>
                    <Col md>
                        <JTable  responsive>
                            <JvCaption>({saldo} de {limite} no máximo)</JvCaption>
                            <JTHead>
                                <tr>
                                    <th className="text-center" style={{ width: '2.5rem' }}>
                                        <ButtonTrash onClick={() => removerTudo()} icon={faTrashAlt} />
                                    </th>
                                    <th>UF</th>
                                </tr>
                            </JTHead>
                            <JTBody>
                                {listaPercurso.map((item: infPercurso) => (
                                    <tr key={item.id} 
                                        className={item.id.toString() === selecionado.toString() ? 'table-danger' : ''}>
                                        <td className="text-center">
                                            <ButtonRemover
                                                onClick={() => handleRemover({ id: item.id, title: item.uf })} />
                                        </td>
                                        <td>
                                            {item.uf}
                                        </td>
                                    </tr>
                                ))}
                            </JTBody>
                        </JTable>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        {showRota && (
            <RotaModal show={showRota} onHide={handleCloseModalRota} ufini={form.ufini} uffim={form.uffim} />
        )}
        {ConfirmModal}
        {ModalMessageEl}
    </>)
}